<ng-container *ngIf="initialized">
<!-- Outer page: white background -->
<div class="hp-outer-page">
  <div class="hp-phone-frame">
    <main class="hp-main" role="main">

      <!-- Logo block -->
      <div class="hp-logo-block">
        <h1 class="hp-logo-title">
          <img src="assets/healthpicks/images/logo.svg" alt="Health Picks" class="hp-logo-img" />
        </h1>
      </div>

      <!-- Input area -->
      <div class="hp-input-area">

        <h2 class="hp-card-title">認証メールを確認してください</h2>

        <p class="hp-note">
          登録したメールアドレスに送信した認証メールを確認し、登録を完了してください。
        </p>

        <!-- Info box -->
        <div class="hp-info-box">
          <div class="hp-info-box-header">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <rect x="2" y="4" width="20" height="16" rx="2"/>
              <path d="M22 7l-10 7L2 7"/>
            </svg>
            <strong>メールが届かない場合</strong>
          </div>
          <p class="hp-info-box-text">
            dx-utility.com のドメインからメールが届きます。届かない場合は、迷惑メールフォルダをご確認ください。
          </p>
          <div class="hp-divider"></div>
          <p class="hp-resend-text">
            認証メールの再送信は
            <button type="button" class="hp-link" (click)="navigateToResend()">
              こちら
            </button>
          </p>
        </div>

      </div>

    </main>
  </div>
</div>
</ng-container>
